import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { PatientDemographics } from '~/features/demographics/demographics/PatientDemographics';
import { useChart } from '~/features/admissions/charts/ChartContext';

export function PatientDemographicsRoute() {
	const { stayId } = useChart();
	return (
		<Section header={<SectionTitle title="Demographics" />}>
			<PatientDemographics stayId={stayId} />
		</Section>
	);
}
